import React,{useState} from 'react'
import {AiTwotoneHome} from 'react-icons/ai'
import {MdOutlineCategory,MdContactPhone} from 'react-icons/md'
import {  Link } from 'react-router-dom';
import {BsCartPlusFill} from 'react-icons/bs'
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { GiHamburgerMenu } from 'react-icons/gi';

function Header() {
  const state = useSelector((state) => state.reducer) //ItemAddReducer is fileName

  const [mobileshow, setMobileShow] = useState(false);
  const mobilehandleClose = () => setMobileShow(false);
  const mobilehandleShow = () => setMobileShow(true);

  return (
    <>
    <div className="sticky-top">
    <h4 className="web_name">Book Store</h4>
    <header className="header  d-flex justify-content-center align-items-center ">
        <Link className="nav-link" to ="/" ><span className='headericon'><AiTwotoneHome /></span> <span className='headertext'>Home</span></Link>
        <Link className="nav-link" to ="/category"><span className='headericon'><MdOutlineCategory /></span><span className='headertext'>  Category</span></Link>
        <Link className="nav-link" to ="/contact"><span className='headericon'><MdContactPhone /> </span><span className='headertext'> Contact Us</span></Link>
        <Link className="nav-link navblue-color " to ="/cart"><span className='headericon'><BsCartPlusFill /></span> <span className='headertext'>Cart [ {state.length} ]</span></Link>
    </header>
    </div>
    <nav className="Mobileheader  ">
                <h1 className="mobile-header-nav " onClick={mobilehandleShow}>
                <GiHamburgerMenu/>
                </h1>

                <Modal show={mobileshow} onHide={mobilehandleClose} className="px-3 py-3 ">
                    <Modal.Header closeButton>
                    <Modal.Title >
                        <div>
                        <h4 className=" Mobile-web_name">Book Store</h4>
                        </div>
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <div className=" mobileheader">
                    <Link className="nav-link" to ="/" ><span className='headericon'><AiTwotoneHome /></span> <span className='headertext'>Home</span></Link>
                    <Link className="nav-link" to ="/category"><span className='headericon'><MdOutlineCategory /></span><span className='headertext'>  Category</span></Link>
                    <Link className="nav-link" to ="/contact"><span className='headericon'><MdContactPhone /> </span><span className='headertext'> Contact Us</span></Link>
                    <Link className="nav-link navblue-color " to ="/cart"><span className='headericon'><BsCartPlusFill /></span> <span className='headertext'>Cart [ {state.length} ]</span></Link>

                    </div>  
                    </Modal.Body>
                    <Modal.Footer>
                    <p className="btn-remove" onClick={mobilehandleClose}>
                        Close
                    </p>
                    </Modal.Footer>
                </Modal>
                </nav>
    
    </>
  )
}

export default Header